module.exports = __webpack_public_path__ + "img/matgone.1c0918a5.png";